import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentAttributes } from "../../../ducks/editFeature/selectors";
import { setAttributes } from "../../../ducks/editFeature/editFeature";

const GOOGLE_DRIVE = "drive.google.com";
const DROPBOX = "dropbox.com";

export const getIdFromUrl = (url: string) => url.match(/[-\w]{25,}/);

export const googleDriveUrlFormat = (str: string) => {
  const fileId = getIdFromUrl(str);

  return `https://docs.google.com/uc?id=${fileId}`;
};

export const dropboxUrlFormat = (str: string) => str.replace(DROPBOX, "dl.dropboxusercontent.com");

export const formatUrls = (urls: string[]) =>
  urls.map(url => {
    if (url.includes(GOOGLE_DRIVE)) return googleDriveUrlFormat(url);
    if (url.includes(DROPBOX)) return dropboxUrlFormat(url);

    return url;
  });

export const useImageAttributeSrc = (name: string, value?: string) => {
  const dispatch = useDispatch();
  const currentAttributes = useSelector(getCurrentAttributes);
  const [isOpenPreview, setOpen] = useState(false);
  const [previewImages, setPreview] = useState([]);

  const urls = value && formatUrls(value.split(";"));

  const deleteImageAttribute = useCallback(
    (imageSrc: string) => {
      const updateUrls = urls.filter(url => url !== imageSrc).join(";");

      const updateAttribute = currentAttributes.map(attribute => {
        if (attribute.name === name) {
          return { ...attribute, value: updateUrls };
        }

        return attribute;
      });

      dispatch(setAttributes(updateAttribute));
    },
    [urls, name, currentAttributes],
  );

  const expandImage = useCallback(
    (imageSrc: string) => {
      const preview = urls.filter(url => url !== imageSrc).map(url => ({ src: url, fileName: null }));

      setPreview([{ src: imageSrc, fileName: null }, ...preview]);

      setOpen(true);
    },
    [urls, setOpen, setPreview],
  );

  const closePreview = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  return { urls, isOpenPreview, previewImages, deleteImageAttribute, expandImage, closePreview };
};
